import React from 'react';

import Heading from '@jpp/atoms/Heading';
import Button from '@jpp/molecules/Button';
import ProductCard from '@jpp/molecules/ProductCard';
import BackTo from '@jpp/organisms/BackTo';
import Container from '@jpp/shared/Grid/Container';
import Flex from '@jpp/shared/Grid/Flex';
import Row from '@jpp/shared/Grid/Row';
import Section from '@jpp/shared/Grid/Section';
import { WYSIWYG } from '@jpp/shared/WYSIWYG/WYSIWYG';
import ErrorTemplate from '@jpp/templates/Error';
import { trackGoogleProductImpression } from 'common/tracking/product';
import { EProductRenderedBy } from 'common/tracking/types';
import { ECtaTheme, EPageType } from 'common/typings/enums';
import { IProductsTemplateProps } from 'common/typings/types';
import { SERVER_ERROR_STATUS_CODE } from 'common/utils/constants';

import './Products.scss';

const ROOT_CLASSNAME = 'Products';

const Products: React.FunctionComponent<IProductsTemplateProps> = ({
  page = {},
}) => {
  const { acf_fields, products } = page;
  const acf = page.acf || acf_fields;

  React.useEffect(() => {
    if (products) {
      trackGoogleProductImpression(products, EProductRenderedBy.Plp);
    }
  }, []);

  if (!acf || !products) {
    return <ErrorTemplate statusCode={SERVER_ERROR_STATUS_CODE} />;
  }

  const { description, heading } = acf;
  const title = heading || page.title;

  return (
    <>
      <BackTo href={`/${EPageType.Shop}`} label="the beer shop" />

      <Section>
        <Container>
          <Row>
            <Flex colLg={9} colMd={10}>
              <Heading className={`${ROOT_CLASSNAME}__heading`} priority={1}>
                {title}
              </Heading>

              {description && (
                <WYSIWYG
                  className={`${ROOT_CLASSNAME}__description`}
                  content={description}
                />
              )}
            </Flex>
          </Row>

          <Row>
            {products.map((product, index) => {
              return (
                <Flex
                  colLg={4}
                  colMd={6}
                  col={12}
                  key={`${product.sku}${index}`}
                  className={`${ROOT_CLASSNAME}__card`}
                >
                  <ProductCard pdp={product} bodyOverflow={false} />
                </Flex>
              );
            })}
          </Row>

          <Row>
            <Flex
              colLg={4}
              colMd={6}
              col={12}
              className={`${ROOT_CLASSNAME}__button-wrapper mx-auto`}
            >
              <Button
                behaviour="router"
                link={`/${EPageType.Shop}`}
                className={`${ROOT_CLASSNAME}__button`}
                theme={ECtaTheme.BrandOutline}
                isFull={true}
              >
                Shop home
              </Button>
            </Flex>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default Products;
